import { useState, useEffect } from "react";
import heroImage1 from "../../assets/images/banner.jpg";
import heroImage2 from "../../assets/images/main-img-mobile.jpg";
import Text from "../../components/Text";
import { FaApple, FaGooglePlay } from "react-icons/fa";
import IconText from "../../components/IconText";
import { screens } from "tailwindcss/defaultTheme";

const HeroSection = () => {
  const [scrollY, setScrollY] = useState(0);
  const [currentHeroImage, setCurrentHeroImage] = useState(heroImage1);

  const style = {
    backgroundImage: `url(${currentHeroImage})`,
    backgroundPositionY: `${scrollY === 0 ? "center" : -scrollY / 15 + "px"}`,
  };

  useEffect(() => {
    window.addEventListener("scroll", () => {
      setScrollY(window.scrollY);
    });
  }, [scrollY]);

  useEffect(() => {
    const isCurrentWidthSmall =
      window.innerWidth <= Number(screens.sm.slice(0, -2));

    setCurrentHeroImage(isCurrentWidthSmall ? heroImage2 : heroImage1);

    window.addEventListener("resize", () => {
      if (window.innerWidth <= Number(screens.sm.slice(0, -2))) {
        setCurrentHeroImage(heroImage2);
      } else {
        setCurrentHeroImage(heroImage1);
      }
    });
  }, [currentHeroImage]);

  return (
    <div
      className={`relative w-full h-[500px] overflow-hidden transition-all duration-700 xs:rounded-br-[200px] sm:rounded-br-none`}
    >
      <div
        className="w-full h-[600px] overflow-hidden flex items-center bg-center bg-cover transition-all duration-700 bg-no-repeat -translate-y-14"
        style={style}
      >
        <div className="desc absolute top-1/2 left-0 -translate-y-1/2 translate w-full text-center text-white">
          <div className="xs:w-11/12 sm:w-2/3 md:w-1/2 px-4 mx-auto">
            <div className="row flex -mx-4 flex-wrap flex-col bg-transparent">
              <div className="flex flex-col items-center my-2">
                <Text
                  text="Virtual Nutrition Consulting For everyone, at your own cost"
                  classes="xs:text-[35px] sm:text-[40px] lg:text-[50px] font-medium"
                  component="h1"
                />
                <div className="xs:w-4/5 md:w-2/3 xs:hidden md:block my-4">
                  <Text
                    text="Nutrium is nutrition software for professionals to manage
                    their business while focusing on their clients' success."
                    classes="text-base"
                    component="p"
                  />
                </div>

                <div className="flex items-center text-white justify-center">
                  <a className="ml-1 flex justify-center" href="#">
                    <IconText
                      iconInfo={{ Icon: FaApple, classes: "w-5 h-5" }}
                    />
                  </a>
                  <a className="ml-1 flex justify-center" href="#">
                    <IconText
                      iconInfo={{ Icon: FaGooglePlay, classes: "w-4 h-4" }}
                    />
                  </a>
                  <div className="p-2">
                    <Text text={"Get the app today!"} />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default HeroSection;
